import {Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {RouteService} from '../../../../services/route/route.service';
import {SnackService} from '../../../../services/snack/snack.service';
import {BookingSearchFilter, BookingsService} from '../../../../services/bookings/bookings.service';
import {CustomerService} from '../../../../services/customer/customer.service';
import {EventService} from '../../../../services/event/event.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {MatMenuTrigger} from '@angular/material/menu';
import {UtilService} from '../../../../services/util/util.service';
import {StorageService} from '../../../../services/storage/storage.service';
import {ConfirmDialogComponent} from '../../../../components/confirm-dialog/confirm-dialog.component';
import {LegalPersonService} from '../../../../services/legalPerson/legalPerson.service';
import {LegalPersonList} from '../../../../generated/sales-terminal-client';
import {ADD_TO_CART_ACTION_RESULT} from '../../sales-terminal.constants';
import {
  BookingSearchItem,
  BookingSortBy,
  BookingStatus,
  BookingType,
  EventLimited, EventStatus,
  LegalPersonSimple,
  SortOrderEnum
} from '../../../../generated/sales-terminal-client';
import {Subscription} from 'rxjs';
import {cloneDeep, find} from 'lodash-es';
import moment from 'moment';
import {NavigationEnd, Router} from '@angular/router';
import {BOOKING_TOOLTIP_MAX_LENGTH} from '../bookings.constants';
import {ScrollLoad} from '../../../../components/scroll-load-component/ScrollLoad';
import {InvoiceService} from '../../../../services/invoice/invoice.service';
import {ValidationService} from '../../../../services/validation/validation.service';
import {Customer} from '../../../../generated/customer-client';
import {finalize} from 'rxjs/operators';
import {Privileges} from '../../../admin/privileges/privileges.constants';
import {PageableResult} from '../../../../components/scroll-load-component/scroll-load.component';
import {CartService} from '../../../../services/cart/cart.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { BookingListSortByOption } from 'src/app/interfaces/sort-by-option.interface';
import {STATUS_DRAFT} from '../../event-search/event-search.constants';
import {DatePickerConfig} from '../../../../components/datepicker/datepicker.component';
import {CentrePropertyService} from "../../../../services/centre-property/centre-property.service";

@Component({
  selector: 'app-bookings-list',
  templateUrl: './bookings-list.component.html',
  styleUrls: ['./bookings-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BookingsListComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) private _promocodeInfoTrigger: MatMenuTrigger;
  static STORAGE_SEARCH_RESULTS_PAGE_SIZE = 'bookingsResult.pageSize';
  static STORAGE_SEARCH_RESULTS_SORT_BY = 'bookingsResult.sortBy';
  static STORAGE_SEARCH_FILTERS = 'bookingsResult.filters';

  public isLoading = false;
  private _subscriptions: Subscription[] = [];
  private _defaultFilters: BookingSearchFilter = {
    customerUuid: null,
    bookingNumber: null,
    eventId: null,
    date: null,
    dateEnd: null,
    dueDate: null,
    dueDateEnd: null,
    type: null,
    status: BookingStatus.Active,
    invoiceNumber: null,
    legalPersonId: null
  };
  public filters: BookingSearchFilter = cloneDeep(this._defaultFilters);
  public eventStatuses: EventStatus[] = [];
  public eventStatusId: number = null;
  public results: PageableResult<BookingSearchItem> = {items: [], total: 0};
  public pageSize = 30;
  public page = 1;
  public statuses: BookingStatus[] = Object.values(BookingStatus);
  public types: BookingType[] = Object.values(BookingType);
  public searchDone = false;
  public noSearches = true;
  public showMobileFilters: boolean = false;
  public Privileges = Privileges;
  sortByOptions: BookingListSortByOption[] = [
    { id: 1, field: BookingSortBy.BookingDate, order: SortOrderEnum.Desc, title: 'general.api_users_sort_by_booking_date_desc' },
    { id: 2, field: BookingSortBy.BookingDate, order: SortOrderEnum.Asc, title: 'general.api_users_sort_by_booking_date_asc' },
    { id: 3, field: BookingSortBy.DueDate, order: SortOrderEnum.Asc, title: 'general.api_users_sort_by_due_date_asc' },
    { id: 4, field: BookingSortBy.DueDate, order: SortOrderEnum.Desc, title: 'general.api_users_sort_by_due_date_desc' },
  ];
  sortBy: number = this.sortByOptions[0].id;

  public eventScrollLoad: ScrollLoad<EventLimited> = this.eventService.getScrollLoad(50);
  public legalPersonScrollLoad: ScrollLoad<LegalPersonList> = this.legalPersonService.getScrollLoad();
  public customerScrollLoad: ScrollLoad<Customer> = this.customerService.getScrollLoad();

  private _defaultDateConfig: DatePickerConfig = {range: true, autoBindDates: true, allowDateClear: true, noHint: true}
  public bookingDateConfig: DatePickerConfig = {
    label: 'general.api_reservation_table_date',
    ...this._defaultDateConfig
  }
  public bookingDueDateConfig: DatePickerConfig = {
    label: 'general.api_reservation_table_due_date',
    ...this._defaultDateConfig
  }

  constructor(private router: Router,
              private routeService: RouteService,
              private snackService: SnackService,
              private bookingsService: BookingsService,
              private translateService: TranslateService,
              private storageService: StorageService,
              private cartService: CartService,
              private dialog: MatDialog,
              public utilService: UtilService,
              public customerService: CustomerService,
              public eventService: EventService,
              public authService: AuthService,
              public centrePropertyService: CentrePropertyService,
              public legalPersonService: LegalPersonService,
              public invoiceService: InvoiceService,
              public validationService: ValidationService) {
    if (storageService.get(BookingsListComponent.STORAGE_SEARCH_RESULTS_PAGE_SIZE)) {
      this.pageSize = parseInt(storageService.get(BookingsListComponent.STORAGE_SEARCH_RESULTS_PAGE_SIZE), 0);
    }
    if (storageService.get(BookingsListComponent.STORAGE_SEARCH_RESULTS_SORT_BY)) {
      this.sortBy = parseInt(storageService.get(BookingsListComponent.STORAGE_SEARCH_RESULTS_SORT_BY), 0);
    }
    if (storageService.get(BookingsListComponent.STORAGE_SEARCH_FILTERS)) {
      this.filters = JSON.parse(storageService.get(BookingsListComponent.STORAGE_SEARCH_FILTERS));
      this.storageService.remove(BookingsListComponent.STORAGE_SEARCH_FILTERS);
      if (this.filters.eventId) {
        this.eventService.getEvent(this.filters.eventId).subscribe(res => {
          this.eventScrollLoad.object = res;
        });
      }
      if (this.filters.legalPersonId) {
        this.legalPersonService.get(this.filters.legalPersonId).subscribe(res => {
          this.legalPersonScrollLoad.object = res;
        });
      }
      if (this.filters.customerUuid) {
        this.customerService.get(this.filters.customerUuid).subscribe(res => {
          this.customerScrollLoad.object = res;
        });
      }
      this.search();
    }
    this._subscriptions.push(this.utilService.bookingQueried.subscribe((event) => {
      this.filters.eventId = event.id;
      this.eventScrollLoad.object = event;
      this.search();
    }));
    router.events.subscribe((event) => {
      if (this.isComponentReload(event)) {
        this.isLoading = true;
        setTimeout(() => this.search(this.page), 0);
      }
    });
  }

  public ngOnInit(): void {
    this.eventService.findAllEventStatuses().subscribe((eventStatuses) => {
      this.eventStatuses = eventStatuses;
      if (!this.authService.checkPrivileges(Privileges.EVENT_VIEW_PREPARATION)) {
        this.eventStatuses = this.eventStatuses.filter(item => item.id !== STATUS_DRAFT);
      }
    });
  }
  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._subscriptions = [];
  }

  private isComponentReload(event: any): boolean {
    return event instanceof NavigationEnd &&
      event.url === '/app/sales-terminal/bookings' &&
      this.results.total !== 0;
  }

  public get isList(): boolean {
    return this.routeService.url === '/app/sales-terminal/bookings';
  }

  get sort(): BookingListSortByOption {
    return find(this.sortByOptions, { id: this.sortBy });
  }

  public search(page = 1): void {
    this.showMobileFilters = false;
    this.searchDone = true;
    this.isLoading = true;
    this.noSearches = false;
    this.results = {items: [], total: 0};
    this.page = page;
    const filters = cloneDeep(this.filters);
    if (filters.date) {
      filters.date = this.getUnixDate(filters.date);
      if (filters.dateEnd) {
        filters.dateEnd = this.getUnixDate(filters.dateEnd);
      }
    }
    if (filters.dueDate) {
      filters.dueDate = this.getUnixDate(filters.dueDate);
      if (filters.dueDateEnd) {
        filters.dueDateEnd = this.getUnixDate(filters.dueDateEnd);
      }
    }
    if (!filters.eventId) {
      this.eventScrollLoad.reset();
    }
    this.bookingsService.search({
      page: this.page,
      pageSize: this.pageSize,
      sortBy: this.sort.field,
      sortOrder: this.sort.order,
      filters: filters
    }).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe((searchResults) => this.results = searchResults);
  }

  private getUnixDate(date: number): number {
    return moment(date).startOf('day').add(moment().utcOffset(), 'minutes').valueOf() / 1000;
  }

  public get isFormValid(): boolean {
    let check = true;
    Object.keys(this.filters).forEach((key) => {
      if (['bookingNumber', 'invoiceReferenceNumber'].indexOf(key) !== -1 &&
        !this.validationService.emptyOrNumeric((this.filters as any)[key], true)) {
        check = false;
      }
    });
    return check && this.checkAutocompleteValues;
  }

  public get checkAutocompleteValues(): boolean {
    return this.checkCustomerAutocomplete && this.checkEventAutocomplete;
  }

  private get checkCustomerAutocomplete(): boolean {
    return !(this.customerScrollLoad.object && !this.filters.customerUuid);
  }
  private get checkEventAutocomplete(): boolean {
    return !(this.eventScrollLoad.object && !this.filters.eventId);
  }

  public clearFilters(): void {
    this.filters = cloneDeep(this._defaultFilters);
    this.filters.status = null;
    this.noSearches = true;
    this.eventStatusId = null;
    this.eventScrollLoad.reset();
    this.legalPersonScrollLoad.reset();
    this.customerScrollLoad.reset();
  }

  // TODO remove once new invoice download is implemented
  public downloadInvoice(booking: BookingSearchItem): void {
    this.bookingsService.getInvoice(booking.customer.uuid, booking.legalPersonId, booking.id).subscribe((blob) => {
      const legalPerson = booking.legalPersonId && find(booking.customer.legalPersons, { id: booking.legalPersonId });
      const fileName = (legalPerson ? legalPerson.name : (booking.customer.firstName + booking.customer.lastName)) + '_' + booking.invoiceNumber +
        '_' + moment(booking.dueDate).add(-1, 'day').format('DDMMYYYY');
      const fileData = UtilService.getFileData(fileName, 'html');
      this.utilService.previewOrPrintFile(
        new Blob([blob], { type: fileData.mime }),
        '@media print { @page { size: portrait; margin: 0; } html { margin: 0 !important; padding: 0 !important; } body { margin: 10mm !important; padding: 0 !important; } * { font-size: 12px; } }',
        'invoice' + booking.id,
        'html',
        fileName.replace(' ', '')
      );
    });
  }

  public openView(item: BookingSearchItem): void {
    this.routeService.navigate('/app/sales-terminal/bookings/view/' + item.id);
  }

  public eventView(eventId: number): void {
    this.storageService.set(BookingsListComponent.STORAGE_SEARCH_FILTERS, JSON.stringify(this.filters));
    this.routeService.navigate('/app/sales-terminal/search/event/' + eventId);
  }

  public openWaybill(item: BookingSearchItem): void {
    this.bookingsService.openedFromList = true;
    this.routeService.navigate('/app/sales-terminal/bookings/view/' + item.id + '/waybill');
  }
  public createWaybill(item: BookingSearchItem): void {
    this.bookingsService.openedFromList = true;
    this.routeService.navigate('/app/sales-terminal/bookings/view/' + item.id + '/waybill');
  }

  public cancel(bookingId: number): void {
    const dialogConfig: MatDialogConfig = {
      height: '10%',
      width: '40%',
      panelClass: 'xs-popup',
      data: {
        title: this.translateService.instant('general.api_reservation_confirm_cancel_title'),
        description: this.translateService.instant('general.api_reservation_confirm_cancel_description'),
        buttonCancel: this.translateService.instant('general.api_reservation_confirm_cancel_button_cancel'),
        buttonOk: this.translateService.instant('general.api_reservation_confirm_cancel_button_ok')
      }
    };
    if (!this.bookingsService.cartDraftEvent?.isDraft) {
      dialogConfig.data.additionalActions = [
        {
          title: this.translateService.instant('general.api_reservation_confirm_cancel_button_ok_and_add_to_cart'),
          result: ADD_TO_CART_ACTION_RESULT
        }
      ];
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoading = true;
        this.bookingsService.cancelBooking(typeof res === 'string' && res === ADD_TO_CART_ACTION_RESULT, bookingId).pipe(
          finalize(() => this.isLoading = false)
        ).subscribe(() => {
          this.cartService.getCart().subscribe(() => {
            this.snackService.showSuccess(this.translateService.instant('general.api_reservation_cancel_succeed'));
            this.search();
          });
        });
      }
    });
  }

  public getCustomerLegalPersonName(legalPersons: LegalPersonSimple[], legalPersonId: number): string {
    const legalPerson = legalPersons.find(legalPerson => legalPerson.id === legalPersonId);
    return legalPerson && legalPerson?.name;
  }

  public getBookingNotesTooltip(inNotes: string): string {
    return inNotes.length > BOOKING_TOOLTIP_MAX_LENGTH ? (inNotes.substring(0, BOOKING_TOOLTIP_MAX_LENGTH) + '...') : inNotes;
  }

  public toggleFilters(): void {
    this.showMobileFilters = !this.showMobileFilters;
  }

  displaySortWith(id: number): string | undefined {
    return find(this.sortByOptions, {id: id})?.title;
  }

  updateLocalStorage(): void {
    this.search();
    this.storageService.set(BookingsListComponent.STORAGE_SEARCH_RESULTS_SORT_BY, this.sortBy);
  }

  public displayFilterSelectedOption(id: number, list: Array<any>): string {
    return find(list, {id: id})?.name;
  }

  public clearEvent(): void {
    this.filters.eventId = null;
    this.eventScrollLoad.reset();
  }
}
